import { put } from './requests'

const resourcePath = 'multi_step_signup'

export function updateSignup (onboarding) {
  return put(resourcePath, { onboarding })
}
